module.exports = __webpack_public_path__ + "static/BeyondBE-02f7947cc8da402469306c8b3e58ca80.png";